class BaseEmployeeSelector {
    constructor(options) {
        this.formElementGuid = options.formElementGuid;
        this.formElementName = options.formElementName;
        this.selectorElement = document.getElementById(options.selectorElementId);
        this.valueInput = document.getElementById(options.valueInputId);
        this.employees = options.employeeData || [];
        this.placeholder = options.placeholderText || '';
        this.noResultLabel = options.noResultLabel || '';
        this.loading = false;
        this.openingPrevented = false;
    }
    init() {
        this.load(this.employees, true);
        this.addEventListeners();
        this.markAsReady();
    }
    load(data, initialLoad = false) {
        this.employees = data;
        this.employeeCount = data.length - 1;
        this.loading = true;
        this.populateSelector(this.employees);
        this.loading = false;
        if (this.openingPrevented === true) {
            $(this.selectorElement).select2('open');
            this.openingPrevented = false;
        }
    }
    markAsReady() {
        this.valueInput.dataset.loaded = true;
        this.valueInput.dispatchEvent(new CustomEvent('EmployeePickerReady', { bubbles: true }));
    }
    attachEventHandlers() {
        const self = this;
        $(this.selectorElement).on('select2:opening', function (e) {
            if (self.loading) {
                self.openingPrevented = true;
                e.preventDefault();
            }
        });
    }
    addEventListeners() {
        this.valueInput.addEventListener('OnCheckSelection', (event) => {
            event.detail.hasSelection = $(this.selectorElement).select2('data').some(item => !item.disabled);
        });
        this.valueInput.addEventListener('OnLoadingStateChanged', (event) => {
            this.loading = event.detail.loading;
        });
        this.valueInput.addEventListener('OnRepopulation', (event) => {
            const isInitialLoad = event.detail.initialLoad === true;
            this.clear(isInitialLoad);
            const url = event.detail.manager != null && !!event.detail.manager.trim() ?
                `/api/km/manager/${event.detail.manager}/${event.detail.countryCode}/employees` :
                `/api/km/costcenter/${event.detail.costcenter}/employees`;
            fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(data => {
                    this.load(data, isInitialLoad);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        });
    }
    populateSelector(employees) {
        employees.forEach((employee, index) => {
            this.addOptionToSelector(index, employee);
        });
        this.loadSelect2(this.placeholder);
    }
    onEmployeeSelected(employee) { }
    triggerRepopulationEvents(personalNumber, countryCode) { }
    loadSelect2() { }
    clear(isInitialLoad) {
        if (!isInitialLoad) {
            this.valueInput.value = "";
        }
        this.employees = [];
        while (this.selectorElement.options.length > 0) {
            this.selectorElement.remove(0);
        }
    }

    addOptionToSelector(index, employee, selected, prepend) {
        const baseId = `${this.formElementGuid}_${index}`;
        const baseName = `${this.formElementName}_${index}`;
        const choiceId = `${baseId}_option`;
        const choiceName = `${baseName}_option`;
        const caption = !!employee?.name?.trim() ? `${employee.name} (${employee.personalNumber})` : this.newEmployeeLabel;
        var option = new Option(caption, index);
        option.id = choiceId;
        option.name = choiceName;
        option.selected = selected ?? false;
        option.dataset.baseId = baseId;
        option.dataset.fromapi = employee != null;

        if (employee != null) {
            option.dataset.personalNumber = employee?.personalNumber;
            option.dataset.countryCode = employee?.countryCode;
        }
        if (prepend) {
            this.selectorElement.prepend(option);
        } else {
            this.selectorElement.append(option);
        }
    }
    async setExtraEmploymentData(personalNumber, countryCode, emailFieldSelector, phoneFieldSelector) {
        try {
            const response = await fetch(`/api/km/employee/${personalNumber}/${countryCode}/info`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });

            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

            const data = await response.json();
            this.updateField(emailFieldSelector, data?.email, { email: data?.email || '' });
            this.updateField(phoneFieldSelector, data?.phone, { phone: data?.phone || '', countryCode: data?.countryCode || '' });

        } catch (error) {
            console.error('Error fetching employment data:', error);
        }
    }
    updateField(fieldSelector, value, eventData = {}) {
        const field = document.querySelector(fieldSelector);
        if (!field) return;

        const hasValue = value && value.trim();
        field.value = hasValue ? value : '';
        field.dispatchEvent(new CustomEvent("change", { detail: eventData }));
    }
    getEmployee(personalNumber) {
        const employee = this.employees.find(emp => emp.personalNumber === personalNumber);
        return employee || null;
    }
}

export default BaseEmployeeSelector;